(function(){
  var ROOT_SELECTOR = '.jcg';

  function init(root){
    if(!root) return;
    if(root._jcgMarqueeDestroy) root._jcgMarqueeDestroy();

    var carousel = root.querySelector('.jcg-carousel');
    var track = root.querySelector('.jcg-loop-track');
    var primary = track && track.querySelector('.jcg-loop-set:not([data-jcg-clone])');
    if(!carousel || !track || !primary) return;

    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var frame = 0;
    var resizeTimer = 0;
    var resumeTimer = 0;
    var observer = null;
    var setWidth = 0;
    var offset = 0;
    var speed = 0;
    var lastTime = 0;
    var paused = false;
    var activeMode = mobileQuery.matches ? 'mobile' : 'desktop';

    function removeClones(){
      track.querySelectorAll('[data-jcg-clone="true"]').forEach(function(clone){ clone.remove(); });
    }

    function setPaused(value){
      paused = value;
      lastTime = performance.now();
    }

    function stop(){
      if(frame) cancelAnimationFrame(frame);
      frame = 0;
      lastTime = 0;
    }

    function tick(now){
      if(!frame) return;
      if(!lastTime) lastTime = now;
      var delta = Math.min(now - lastTime, 100);
      lastTime = now;

      if(!paused && setWidth > 0 && speed > 0){
        if(activeMode === 'mobile'){
          var nextScroll = carousel.scrollLeft + (speed * delta / 1000);
          if(nextScroll >= setWidth) nextScroll = nextScroll % setWidth;
          carousel.scrollLeft = nextScroll;
        } else {
          offset = (offset + (speed * delta / 1000)) % setWidth;
          track.style.transform = 'translate3d(' + (-offset) + 'px,0,0)';
        }
      }
      frame = requestAnimationFrame(tick);
    }

    function start(){
      stop();
      lastTime = performance.now();
      frame = requestAnimationFrame(tick);
    }

    function cloneSet(){
      var clone = primary.cloneNode(true);
      clone.setAttribute('data-jcg-clone','true');
      clone.setAttribute('aria-hidden','true');
      if(mobileQuery.matches) clone.style.setProperty('display','flex','important');
      clone.querySelectorAll('[data-shopify-editor-block]').forEach(function(el){
        el.removeAttribute('data-shopify-editor-block');
      });
      clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function(el){
        el.setAttribute('tabindex','-1');
      });
      clone.querySelectorAll('img').forEach(function(image){ image.loading = 'eager'; });
      track.appendChild(clone);
    }

    function rebuild(){
      var oldWidth = setWidth;
      var phase = 0;

      if(oldWidth > 0){
        if(activeMode === 'mobile'){
          phase = (carousel.scrollLeft % oldWidth) / oldWidth;
        } else {
          phase = offset / oldWidth;
        }
      }

      stop();
      removeClones();
      primary.style.removeProperty('width');
      track.style.transform = 'translate3d(0,0,0)';
      carousel.scrollLeft = 0;
      carousel.style.removeProperty('scroll-snap-type');

      if(reduceQuery.matches){
        setWidth = 0;
        speed = 0;
        offset = 0;
        return;
      }

      var slides = Array.from(primary.children);
      var setStyle = getComputedStyle(primary);
      var gap = parseFloat(setStyle.columnGap) || 0;
      setWidth = slides.reduce(function(total, slide){
        return total + slide.getBoundingClientRect().width;
      }, 0) + gap * Math.max(0, slides.length - 1)
        + (parseFloat(setStyle.paddingLeft) || 0)
        + (parseFloat(setStyle.paddingRight) || 0)
        + (parseFloat(setStyle.borderLeftWidth) || 0)
        + (parseFloat(setStyle.borderRightWidth) || 0);
      primary.style.width = setWidth + 'px';
      var viewportWidth = carousel.getBoundingClientRect().width;
      if(!setWidth || !viewportWidth) return;

      var copies = Math.ceil(viewportWidth / setWidth) + 1;
      for(var copy = 0; copy < copies; copy++){
        cloneSet();
      }

      var duration = parseFloat(track.getAttribute('data-jcg-duration')) || 42;
      speed = setWidth / Math.max(duration, 1);
      activeMode = mobileQuery.matches ? 'mobile' : 'desktop';

      if(activeMode === 'mobile'){
        offset = 0;
        track.style.transform = '';
        carousel.style.setProperty('scroll-snap-type','none','important');
        carousel.scrollLeft = (phase * setWidth) % setWidth;
      } else {
        carousel.scrollLeft = 0;
        offset = (phase * setWidth) % setWidth;
        track.style.transform = 'translate3d(' + (-offset) + 'px,0,0)';
      }

      start();
    }

    function scheduleRebuild(){
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(rebuild, 120);
    }

    function pauseForTouch(){
      if(!mobileQuery.matches) return;
      window.clearTimeout(resumeTimer);
      setPaused(true);
    }

    function resumeAfterTouch(){
      if(!mobileQuery.matches) return;
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(function(){ setPaused(false); }, 1800);
    }

    function onMouseEnter(){
      if(!mobileQuery.matches) setPaused(true);
    }

    function onMouseLeave(){
      if(!mobileQuery.matches) setPaused(false);
    }

    function onFocusIn(){ setPaused(true); }

    function onFocusOut(event){
      if(!root.contains(event.relatedTarget)) setPaused(false);
    }

    function onVisibility(){
      lastTime = performance.now();
    }

    carousel.addEventListener('mouseenter', onMouseEnter);
    carousel.addEventListener('mouseleave', onMouseLeave);
    carousel.addEventListener('focusin', onFocusIn);
    carousel.addEventListener('focusout', onFocusOut);
    carousel.addEventListener('touchstart', pauseForTouch, {passive:true});
    carousel.addEventListener('touchend', resumeAfterTouch, {passive:true});
    carousel.addEventListener('touchcancel', resumeAfterTouch, {passive:true});
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('resize', scheduleRebuild);

    if(mobileQuery.addEventListener) mobileQuery.addEventListener('change', scheduleRebuild);
    else if(mobileQuery.addListener) mobileQuery.addListener(scheduleRebuild);
    if(reduceQuery.addEventListener) reduceQuery.addEventListener('change', scheduleRebuild);
    else if(reduceQuery.addListener) reduceQuery.addListener(scheduleRebuild);

    if('ResizeObserver' in window){
      observer = new ResizeObserver(scheduleRebuild);
      observer.observe(carousel);
      observer.observe(primary);
    }

    root._jcgMarqueeDestroy = function(){
      stop();
      window.clearTimeout(resizeTimer);
      window.clearTimeout(resumeTimer);
      removeClones();
      primary.style.removeProperty('width');
      track.style.transform = '';
      carousel.scrollLeft = 0;
      carousel.removeEventListener('mouseenter', onMouseEnter);
      carousel.removeEventListener('mouseleave', onMouseLeave);
      carousel.removeEventListener('focusin', onFocusIn);
      carousel.removeEventListener('focusout', onFocusOut);
      carousel.removeEventListener('touchstart', pauseForTouch);
      carousel.removeEventListener('touchend', resumeAfterTouch);
      carousel.removeEventListener('touchcancel', resumeAfterTouch);
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('resize', scheduleRebuild);
      if(mobileQuery.removeEventListener) mobileQuery.removeEventListener('change', scheduleRebuild);
      else if(mobileQuery.removeListener) mobileQuery.removeListener(scheduleRebuild);
      if(reduceQuery.removeEventListener) reduceQuery.removeEventListener('change', scheduleRebuild);
      else if(reduceQuery.removeListener) reduceQuery.removeListener(scheduleRebuild);
      if(observer) observer.disconnect();
      root._jcgMarqueeDestroy = null;
    };

    rebuild();
  }

  function boot(scope){
    var target = scope || document;
    if(target.matches && target.matches(ROOT_SELECTOR)) init(target);
    target.querySelectorAll && target.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function(event){ boot(event.target); });
})();
